export enum Status {
  INITIAL,
  PENDING,
  ERROR,
  SUCCESS,
}

export interface StatusData<T> {
  status: Status
  data: T
}

export interface PlatformsData {
  contract?: number
  front?: number
  query?: number
}
